export const toHex = (data: ArrayBuffer | Uint8Array): string => {
    const bytes = data instanceof Uint8Array ? data : new Uint8Array(data)
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
}

/** Browser only: call from effects and event handlers. */
export const randomBytes = (length: number): Uint8Array => {
    const bytes = new Uint8Array(length)
    crypto.getRandomValues(bytes)
    return bytes
}

/** Real SHA-256 through Web Crypto. Falls back to random bytes only where Web Crypto is missing. */
export const sha256 = async (data: Uint8Array): Promise<string> => {
    if (typeof crypto !== 'undefined' && crypto.subtle) {
        const digest = await crypto.subtle.digest('SHA-256', data as BufferSource)
        return toHex(digest)
    }

    return toHex(randomBytes(32))
}

export const shorten = (hex: string, head = 12, tail = 6): string => `${hex.slice(0, head)}…${hex.slice(-tail)}`
